module.exports = __webpack_public_path__ + "static/share-254194cfc1b51e5d4de70a0c9d74af4b.jpg";